import { SubscriptionMode } from 'dy-frontend-http-repository/lib/modules/Subscription/enums';
import { SubscriptionResource } from 'dy-frontend-http-repository/lib/modules/Subscription/resources';
import { checkIfSubscriptionTerminated, checkIfSubscriptionPauseScheduled } from '../';

/**
 * Check if resume subscription action allowed
 * @param subscription subscription to use in "resume subscription action allowed" check
 * @returns {boolean} "resume subscription action allowed" flag
 */
export default function checkIfResumeSubscriptionActionAllowed(subscription: SubscriptionResource) {
    if (subscription.mode === SubscriptionMode.MANUAL) {
        // Subscription mode is MANUAL
        return false;
    }

    if (checkIfSubscriptionTerminated(subscription)) {
        // Subscription is terminated
        return false;
    }

    if (!checkIfSubscriptionPauseScheduled(subscription)) {
        // Subscription do NOT have pause scheduled
        return false;
    }

    return true;
}
